import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

/**
 * Title
 *
 * This component is in charge of displaying
 * a order list title
 *
 * @return {jsx}
 */

const Title = ({ className, children }) => <h2 className={className}>{children}</h2>;

/**
 * Display Name
 */
Title.displayName = 'OrderList.Title';

/**
 * PropTypes Validation
 */
const { node, string } = PropTypes;
Title.propTypes = {
  className: string,
  children: node,
};

/**
 * Default Props
 */
Title.defaultProps = {
  className: '',
  children: null,
};

export default styled(Title)`
  margin-bottom: 1rem;

  font-size: ${({ theme: { fonts } }) => fonts.size.big};
  font-weight: ${({ theme: { fonts } }) => fonts.weight.thick};
`;



// WEBPACK FOOTER //
// ./src/components/OrderList/Title/index.js